import { render } from "./CrmSummaryCards.vue?vue&type=template&id=41d99a29&scoped=true"
import script from "./CrmSummaryCards.vue?vue&type=script&lang=js"
export * from "./CrmSummaryCards.vue?vue&type=script&lang=js"

import "./CrmSummaryCards.vue?vue&type=style&index=0&id=41d99a29&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d99a29"]])

export default __exports__